// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2025/5/30
// +-------------------------------------------------------------
// |Time: 15:27
// +-------------------------------------------------------------
export default [
    {
        path: '/order/order-list',
        name: "OrderList",
        meta: {
            title: "订单列表"
        },
        component: () => import("@/views/Order/Order/Index")
    },
]